module.exports = {
  type: 'cart',
  id: 'cart',
  icon: 'shopping-cart',
  title: 'ProjectDetails.cart',
  bodyClass: 'no-padding',
  hidePrices: false,
  requireShipping: true,

  orderDialog: [{
    id: 'suppliers',
    form: [{
        id: 'description',
        type: 'multi',
        label: {
          en: 'Description',
          de: 'Beschreibung',
        }
      },
      {
        id: 'terms',
        type: 'checkbox',
        checkValue: true,
        required: true,
        label: {
          en: 'I have read and accepted the <a href="https://www.creacam.de/agb" target="_blank">terms of service</a>.',
          de: 'Ich habe die <a href="https://www.creacam.de/agb" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert'
        }
      },
      {
        id: 'privacy',
        type: 'checkbox',
        required: true,
        checkValue: true,
        label: {
          en: 'I have read and accepted the <a href="https://www.creacam.de/datenschutz" target="_blank">pricacy policy</a>.',
          de: 'Ich habe die <a href="https://www.creacam.de/datenschutz" target="_blank">Datenschutzhinweise</a> gelesen und akzeptiert'
        }
      }
    ]
  }]
}
